<template>
  <div class="home">
    <div>
      <b-card-group deck>
        <b-card
          header="ログイン"
          header-tag="header"
          title="ユーザーログイン"
        >
        <b-input
          id="inline-form-input-name"
          class="mb-2 "
          placeholder="email"
          type="text"
          v-model="email"
        ></b-input>
        <b-input
          id="inline-form-input-name"
          class="mb-2 "
          placeholder="password"
          type="password"
          v-model="password"
        ></b-input>
          <b-card-text>登録済みで無い方は<span><router-link to="/signup">こちら</router-link></span></b-card-text>
          <b-button @click.prevent="emailSignin" variant="success" class="login-button">ログイン</b-button>
          <b-card-text>または</b-card-text>
          <b-button @click.prevent="googleSignup" variant="primary">グーグルログイン</b-button>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app' 
import "@firebase/auth"
import 'firebase/database'
import db from '@/firebase' 
export default {
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    emailSignin() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(user => {
        console.log(user)
        this.$router.push('/myfavs')
      })
      .catch(err => {
        console.log(err)
      })
    },
    googleSignup() {
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider).then(res => {
        const user = res.user
        console.log(user)
        db.collection('users').add({
          user_id: user.uid,
          email: user.email,
        })
        .then(() => {
          this.$router.push('/myfavs')
        })
        .catch(err => {
          console.log(err)
        })
      })
    }
  }
}
</script>

<style scoped>
.card{
  background-color: bisque;
}
.home{
  width: 70%;
  margin: auto;
}

.mb-2{
  width: 80%;
  margin: auto;
}

.login-button{
  display: inherit;
  margin: auto;
  margin-bottom: 15px;
}
</style>